import { useContext } from "react";
import VectorSourceContext from "Services/VectorSourceProvider";

const useVectorSource = () => {
    return useContext(VectorSourceContext);
};

export default useVectorSource;
